const _ = require('lodash');

// Template
const usercentricsButtonTemplate = require('../../../templates/usercentrics-button-template.hbs');

const _icons = {
	gear: require('../../../img/gear.hbs')(),
	corner: require('../../../img/corner.hbs')(),
	info: require('../../../img/info.hbs')(),
	close: require('../../../img/close.hbs')(),
	infoLayout1: require('../../../img/info-layout-1.hbs')(),
	arrowUp: require('../../../img/arrow-up.hbs')(),
	arrowDown: require('../../../img/arrow-down.hbs')(),
	arrowDownLayout1: require('../../../img/arrow-down-layout-1.hbs')(),
	arrowUpLayout1: require('../../../img/arrow-up-layout-1.hbs')(),
	eyeOpened: require('../../../img/eye-opened.hbs')(),
	eyeClosed: require('../../../img/eye-closed.hbs')(),
	layout9IdCircle: require('../../../img/layout9-id-circle.hbs')(),
	layout9IdCircleClosed: require('../../../img/layout9-id-circle-closed.hbs')(),
	historyLogo: require('../../../img/layout9-history-open.hbs')(),
	historyLogoClosed: require('../../../img/layout9-history-close.hbs')(),
	headerTitleLogoLayout5: require('../../../img/header-title-logo-5.hbs')(),
	layout1HistoryOpen: require('../../../img/layout1-history-open.hbs')(),
	layout1IdCircle: require('../../../img/layout1-id-circle.hbs')(),
  layout1IdCircleClosed: require('../../../img/layout1-id-circle-closed.hbs')(),
  infoGeneric: require('../../../img/info-generic.hbs')(),
};

// Button & Chip
import PrivacyButtonViewController from './privacy-button/privacy-button-view-controller';
import PrivacyChipViewController from './privacy-chip/privacy-chip-view-controller';

// Modals: Corner & Center
import PrivacyCornerModalViewController from './privacy-corner-modal/privacy-corner-modal-view-controller';
import PrivacyCenterModalViewController from './privacy-center-modal/privacy-center-modal-view-controller';
import AboutModelController from './about-model/about-model-controller';

import BannerViewController from './banner/banner-modal-view-controller';
import ConsentsInfoModalViewController from './consents-info-modal/consents-info-modal-view-controller';
import LanguageService from '../directives/laguage-service/language-service';

export default class UserCentricViewController {
	private updateView: any;

	privacyButton: PrivacyButtonViewController;
	privacyChip: PrivacyChipViewController;
	languageService: LanguageService;
	privacyCornerModal: PrivacyCornerModalViewController;
	privacyCenterModal: PrivacyCenterModalViewController;
	aboutModel: AboutModelController;

	public bannerModal: BannerViewController;

	private consentsInfoModal: ConsentsInfoModalViewController;

	private isVisible: boolean;
	private consentsService: any;
	private settingsService: any;
	private utilityService: any;

	constructor(updateView, utilityService) {
		this.isVisible = true;
		this.consentsService = utilityService.consentsService;
		this.settingsService = utilityService.settingsService;
		this.utilityService = utilityService;
		this.updateView = updateView;

		this.bannerModal = new BannerViewController(
			this,
			updateView,
			this.utilityService
		);
		this.languageService = utilityService.languageService;

		this.consentsInfoModal = new ConsentsInfoModalViewController(
			updateView,
			this.utilityService
		);

		this.privacyCornerModal = new PrivacyCornerModalViewController(
			this,
			updateView,
			this.bannerModal,
			this.utilityService
		);
		this.privacyCenterModal = new PrivacyCenterModalViewController(
			this,
			updateView,
			this.bannerModal,
			this.utilityService
		);

		this.privacyButton = new PrivacyButtonViewController(
			updateView,
			utilityService,
			this.privacyCornerModal,
			this.bannerModal,
			this.privacyCenterModal
		);

		this.privacyChip = new PrivacyChipViewController(
			updateView,
			utilityService,
			this.privacyCornerModal,
			this.privacyCenterModal
		);

		this.aboutModel = new AboutModelController(
			updateView,
			utilityService
		);
	}

	get bannerModalController() {
		return this.bannerModal;
	}

	get htmlString(): string {
		if (this.isVisible) {
			return this.getHtml();
		}
		return '';
    }

	static get icons() {
		return _icons;
	}

	private openAboutModal(url) {
		this.aboutModel.visible = true;
		this.aboutModel.url = url;
		this.updateView();
	}

	closeConsentInfoModal() {
		this.consentsInfoModal.visible = false;
		this.updateView();
	}

	openConsentInfoModal(shortid?) {
		this.consentsInfoModal.visible = true;
		this.updateView();
		if (shortid) {
			setTimeout(() => {
				const modalWrapperElement = document.getElementById(
					this.consentsInfoModal.consentsInfoModalId
				);
				const element = modalWrapperElement.querySelector(
					"[data-id='" + shortid + "']"
                );
                const scrollWrapper = document.getElementById('uc-consents-info-search-content');
				if (element) {
                    window.requestAnimationFrame(() => {
                        element.scrollIntoView(true);

                        // Sometimes the scroll gets reset through dom painting. If so, try again.
                        const scrollValue = scrollWrapper.scrollTop;
                        window.requestAnimationFrame(() => {

                            // If the scroll value has changed, scroll again
                            if (scrollValue !== scrollWrapper.scrollTop) {
                                element.scrollIntoView(true);
                            }
                        })
                    })
				}
			}, 100);
		}
	}

	private showHideBanner() {
		this.bannerModal.visible = !this.bannerModal.visible;
		this.updateView();
	}

	private getHtml() {
		this.utilityService.developmentLog('getting whole HTML string');
		const templateData = {

			bannerModal: '',
			centralBannerModal: '',
			privacyButton: this.privacyButton.htmlString,
			privacyCornerModal: this.privacyCornerModal.htmlString,

			privacyChip: this.privacyChip.htmlString,
			privacyCenterModal: this.privacyCenterModal.htmlString,

			consentsInfoModal: this.consentsInfoModal.htmlString,
			aboutModel: this.aboutModel.htmlString,

			layout: this.settingsService.settings.layout,
        };
        if (this.settingsService.settings.firstUserInteraction === 1) {
            // If firstUserInteraction == 1 => standard banner
            templateData.bannerModal = this.bannerModal.htmlString;
        } else if (this.settingsService.settings.firstUserInteraction === 7) {
            // If firstUserInteraction == 7 => central banner
            templateData.centralBannerModal = this.bannerModal.htmlString;
        }
		this.utilityService.developmentLog('got whole HTML string');
		return usercentricsButtonTemplate(templateData);
    }

	public initHandling() {
		this.utilityService.developmentLog(
			'initializing all views from usercentricsViewController'
		);
		this.privacyChip.initHandling();
		this.privacyButton.initHandling();

		this.privacyCenterModal.initHandling();
		this.privacyCornerModal.initHandling();

		this.bannerModal.initHandling();
		this.consentsInfoModal.initHandling();

		this.aboutModel.initHandling();

		this.languageService.initHandling();
	}
}
